export default "__VITE_ASSET__HIfSmyUp__"